'use client'
import "../../public/assets/css/bootstrap.min.css"
import "../../public/assets/css/all.min.css"
import "../../public/assets/css/animate.css"
import "../../public/assets/css/magnific-popup.css"
import "../../public/assets/css/meanmenu.css"
import "../../public/assets/css/swiper-bundle.min.css"
import "../../public/assets/css/nice-select.css"
import "../../public/assets/css/main.css"
import 'react-modal-video/css/modal-video.min.css'

import { Suspense, useEffect, useState } from "react"
import MouseCursor from "./MouseCursor"
import Offcanvas from "./Offcanvas"
import Header1 from "./header/Header1"
import Search from "./Search"
import Breadcrumb from "./Breadcrumb"

import BackToTop from "../elements/BackToTop"
import { Spin } from "antd"
import { useStore } from "../../stores/root-store-context"
import { observer } from "mobx-react-lite"
import FreezeWarningModal from './FreezeWarningModal';
import Footer2 from "./footer/Footer2"
import AppDownloadBanner from "./AppDownloadBanner"

interface BreadcrumbItem {
  label: string;
  path: string;
}

interface LayoutProps {
  headerStyle?: number;
  footerStyle?: number;
  onePageNav?: boolean;
  breadcrumbTitle?: string;
  breadcrumbItems?: BreadcrumbItem[];
  children: React.ReactNode;
}

const Layout = observer(({ 
  headerStyle, 
  footerStyle, 
  onePageNav, 
  breadcrumbTitle, 
  breadcrumbItems, 
  children 
}: LayoutProps) => {
    const { applicationStore } = useStore();

    const [scroll, setScroll] = useState(0)
    const [isOffCanvas, setOffCanvas] = useState(false)
    const handleOffCanvas = () => setOffCanvas(!isOffCanvas)

    const [isSearch, setSearch] = useState(false)
    const handleSearch = () => setSearch(!isSearch)

    return (
        <>
            <Spin spinning={applicationStore.isLoading} className="layout">
                <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
                    <FreezeWarningModal />
                    <div>
                        <MouseCursor />
                        <Offcanvas isOffCanvas={isOffCanvas} handleOffCanvas={handleOffCanvas} />

                        {headerStyle === 1 ?
                            <Suspense fallback={<div>Loading...</div>}>
                                <Header1 scroll={scroll} onePageNav={onePageNav} isOffCanvas={isOffCanvas} handleOffCanvas={handleOffCanvas} isSearch={isSearch} handleSearch={handleSearch} />
                            </Suspense> : null}
                        <Search isSearch={isSearch} handleSearch={handleSearch} />

                        {breadcrumbTitle && 
                            <Breadcrumb 
                                breadcrumbTitle={breadcrumbTitle} 
                                breadcrumbItems={breadcrumbItems} 
                            />
                        }

                        {children}
                    </div>
                    <Footer2 /> 
                    <BackToTop />
                </div>
            </Spin>
            <AppDownloadBanner />
        </>
    )
})
export default Layout;